import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


export const createGratitudeJournal = async (user, journal) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/gratitude-journal`,
            {
                user_id: user.id,
                journal: journal,
            }
        );

        return response;
    } catch (error) {
        console.error(
            "Create gratitude journal error:",
            error.response?.data || error.message
        );
        return null;
    }
};

// LIST
export const getGratitudeJournals = async (userId, filter = "today") => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/gratitude-journal/${userId}`
        );

        return response;
    } catch (error) {
        console.error(
            "Get gratitude journals error:",
            error.response?.data || error.message
        );
        return null;
    }
};

// UPDATE
export const updateGratitudeJournal = async (
    userId,
    id,
    journal
) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/gratitude-journal/${userId}/${id}`,
            {
                journal: journal,
            }
        );

        return response;
    } catch (error) {
        console.error(
            "Update gratitude journal error:",
            error.response?.data || error.message
        );
        return null;
    }
};

// DELETE
export const deleteGratitudeJournal = async (userId, id) => {
    try {
        const response = await axios.delete(
            `${API_BASE_URL}/gratitude-journal/${userId}/${id}`
        );

        return response;
    } catch (error) {
        console.error(
            "Delete gratitude journal error:",
            error.response?.data || error.message
        );
        return null;
    }
};